import React from 'react'

function TenderTextFlordisp() {
  return (
    <embed src="\pdfs\EAT1.3.6_Q-B-DN200_Floor_displacement_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextFlordisp